// extracted by mini-css-extract-plugin
export default {"container":"CookieMessage_container__C29-6"};